module.exports = __webpack_public_path__ + "static/media/agriLogo.b3d38294.jpg";